import { ICON_NAMES, IconRenderer } from "../lib/icons";

export default function IconPicker({ value, onChange }) {
  return (
    <div data-testid="icon-picker" className="grid grid-cols-5 sm:grid-cols-8 gap-2 max-h-56 overflow-y-auto p-1">
      {ICON_NAMES.map((name) => (
        <button
          key={name}
          type="button"
          data-testid={`icon-option-${name}`}
          onClick={() => onChange(name)}
          aria-label={`Choose ${name} icon`}
          className={`min-h-[56px] rounded-2xl border-2 grid place-items-center transition-colors duration-200 ${
            value === name ? "border-primary bg-primary/10" : "border-foreground/15 bg-white hover:bg-secondary"
          }`}
        >
          <IconRenderer name={name} size={28} />
        </button>
      ))}
    </div>
  );
}
